import { useState } from 'react'
import type { InputHTMLAttributes } from 'react'
import { formatSheetAmount } from '@/lib/sheetAmount'

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
  /** Giá trị hiện tại (số). Khi ô đang được gõ, ô giữ nguyên chữ người dùng gõ, chỉ định dạng lại khi rời ô. */
  value: number | null | undefined
  /** Chữ người dùng vừa gõ (chưa phân tích). Bên nhận dùng parseSheetAmount. */
  onTextChange: (text: string) => void
}

/** Ô nhập tiền kiểu Việt Nam: không định dạng lại giữa lúc gõ (tránh nhảy chữ số), định dạng khi rời ô. */
export function SheetAmountInput({ value, onTextChange, onFocus, onBlur, readOnly, ...rest }: Props) {
  const [draft, setDraft] = useState<string | null>(null)
  const shown = draft !== null && !readOnly ? draft : formatSheetAmount(value ?? null)
  return (
    <input
      {...rest}
      type="text"
      inputMode="decimal"
      readOnly={readOnly}
      value={shown}
      onFocus={(e) => {
        setDraft(formatSheetAmount(value ?? null))
        onFocus?.(e)
      }}
      onChange={(e) => {
        setDraft(e.target.value)
        onTextChange(e.target.value)
      }}
      onBlur={(e) => {
        setDraft(null)
        onBlur?.(e)
      }}
    />
  )
}
